<div *transloco="let t">
	<ng-template #consumptionContent let-energyValue>
		<!--        <div [ngClass]="{'w-[100%]': isMobile, 'w-[50%]': !isMobile}" style="padding-left: 25px; padding-top: 25px;">-->
		<!--            <div [ngClass]="{'w-[100%]': isMobile, 'w-[50%]': !isMobile}" [style]="{ 'isMobile':'padding-left: 25px;'? padding-top: 25px;}">-->
		<div
			[ngClass]="{ 'w-[100%]': isMobile, 'w-[50%]': !isMobile }"
			[ngStyle]="{
				'padding-left': isMobile ? '5px' : '25px',
				'padding-top': '25px',
			}">
			<div class="uvi-my-consumption padding-left-20 subheading-2 flex flex-row flex-wrap">
				<div [ngClass]="{ 'w-[100%]': isMobile, 'w-[60%]': !isMobile }" class="flex flex-col">
					<h4>{{ t('uvi.yourConsumption') }}</h4>
				</div>
				<div
					[ngStyle]="{ 'text-align': isMobile ? 'start' : 'end' }"
					[ngClass]="{ 'w-[40%]': isMobile, 'w-[20%]': !isMobile }"
					class="flex flex-col items-center">
					@if (energyValue.costType !== costTypeEnum.COLDWATER) {
						{{ numberUtil.roundConsumptionValues(energyValue.currentConsumption?.value, 0) }}
						kWh
					}
					@if (energyValue.costType === costTypeEnum.COLDWATER) {
						{{ numberUtil.roundConsumptionValues(energyValue.currentConsumption?.value, 2) | number: '1.2' : activeLang }}
						m³
					}
				</div>
			</div>

			<div style="height: 10px"></div>

			@if (energyValue.costType !== costTypeEnum.COLDWATER) {
				<div class="uvi-default-consumption padding-left-20 flex flex-row flex-wrap">
					<div class="subheading-2 flex flex-col" [ngClass]="{ 'w-[100%]': isMobile, 'w-[60%]': !isMobile }">
						@if (energyValue.costType !== costTypeEnum.WARMWATER) {
							<h4>{{ t('uvi.averageConsumption') }}</h4>
						}
						@if (energyValue.costType === costTypeEnum.WARMWATER) {
							<h4>{{ energyValue.averageDinCalculation ? t('uvi.averageConsumptionWwNewDin') : t('uvi.averageConsumptionWw') }}</h4>
						}
					</div>
					<div
						[ngStyle]="{ 'text-align': isMobile ? 'start' : 'end' }"
						[ngClass]="{ 'w-[40%]': isMobile, 'w-[20%]': !isMobile }"
						class="flex flex-col items-center">
						<div>
							{{ numberUtil.roundConsumptionValues(energyValue.averageConsumption, 0) }}
							kWh
						</div>
					</div>
					@if (energyValue.averageDinCalculation) {
						<div
							[ngStyle]="{ 'text-align': isMobile ? 'start' : 'end' }"
							[ngClass]="{ 'w-[20%]': isMobile, 'w-[10%]': !isMobile }"
							class="flex flex-col items-center">
							<div>
								<mat-icon [siTooltip]="t('uvi.avgConsumptionInfo')" [svgIcon]="icons.get('infoOutline')" color="primary"></mat-icon>
							</div>
						</div>
					}
				</div>
			}

			@if (energyValue.costType !== costTypeEnum.COLDWATER) {
				<div class="flex flex-row justify-center items-center">
					@if (energyValue.averageConsumption !== undefined && energyValue.currentConsumption?.value) {
						<div class="rating-box subheading-2">
							<h4 class="w-[10%]">
								@if (energyValue.averageConsumption > energyValue.currentConsumption?.value) {
									<mat-icon [ngClass]="isMobile ? 'rating-icon' : 'rating-icon desktop'" [svgIcon]="icons.get('thumbUp')"></mat-icon>
								}
								@if (energyValue.averageConsumption < energyValue.currentConsumption?.value) {
									<mat-icon [ngClass]="isMobile ? 'rating-icon' : 'rating-icon desktop'" [svgIcon]="icons.get('warning')"></mat-icon>
								}
							</h4>
							<h4 [ngClass]="isMobile ? 'rating-text-mobile' : ''" class="w-[90%]">
								@if (energyValue.averageConsumption > energyValue.currentConsumption?.value) {
									<span>
										{{ t('uvi.consumeLessAverage') }}
									</span>
								}
								@if (energyValue.averageConsumption < energyValue.currentConsumption?.value) {
									<span>
										{{ t('uvi.consumeMoreAverage') }}
									</span>
								}
							</h4>
						</div>
					}
				</div>
			}
		</div>
	</ng-template>
	<vex-page-layout mode="card">
		@if (selectedDate) {
			<ng-container #chartContainer>
				@if (finishedLoading) {
					<ng-container>
						@for (consumption of consumptions; track consumption) {
							<ng-container>
								@if (consumption.costType === costTypeEnum.HEATING) {
									<div class="card p-6" style="margin-bottom: 10px">
										<div class="flex flex-row">
											<div class="headline flex flex-row w-[40%]" style="align-items: center">
												<mat-icon [svgIcon]="icons.get('heating')" class="title-icon" id="icHeating"></mat-icon>
												<h2 class="margin-left-20">{{ t('uvi.heating') }}</h2>
												<mat-icon
													[siTooltip]="t('uvi.toolTipHeating')"
													[svgIcon]="icons.get('infoOutline')"
													class="align-bottom ml-1"
													color="primary"></mat-icon>
											</div>
										</div>
										<div>
											<div class="flex flex-row flex-wrap">
												<div [ngClass]="{ 'w-[100%]': isMobile, 'w-[50%]': !isMobile }" class="flex flex-row">
													<p [ngClass]="setBarStyleByDevice('left')">
														{{ formatDataLabel(consumption.lastYearConsumption.value) }}
													</p>
													<p [ngClass]="setBarStyleByDevice('mid')">
														{{ formatDataLabel(consumption.lastMonthConsumption.value) }}
													</p>
													<p [ngClass]="setBarStyleByDevice('right')">
														{{ formatDataLabel(consumption.currentConsumption.value) }}
													</p>
													<ngx-charts-bar-vertical
														[barPadding]="3"
														[customColors]="customColors"
														[gradient]="false"
														[legendTitle]="t('uvi.legend')"
														[legend]="false"
														[ngClass]="!isMobile ? 'margin-left-40' : ''"
														[results]="chartDataHeating"
														[roundDomains]="true"
														[showYAxisLabel]="showYAxisLabel"
														[view]="diagramSize"
														[xAxisTickFormatting]="xAxisTickFormattingFn"
														[xAxis]="showXAxis"
														[yAxisLabel]="t('uvi.diagramConsumption')"
														[yAxisTickFormatting]="yAxisTickFormattingFn"
														[yAxis]="showYAxis"
														id="chart_heat">
														<ng-template #tooltipTemplate let-model="model">
															<span class="tooltip-label">{{ model.name }}</span>
															<span class="tooltip-value">{{ scaleBy0(model.value) }}</span>
														</ng-template>
													</ngx-charts-bar-vertical>
												</div>
												<ng-template *ngTemplateOutlet="consumptionContent; context: { $implicit: consumption }"></ng-template>
											</div>
											<div class="flex flex-col justify-start items-stretch" style="width: 100%; margin-top: 20px"></div>
										</div>
									</div>
								}
								@if (consumption.costType === costTypeEnum.WARMWATER) {
									<div class="card p-6" style="margin-bottom: 10px">
										<div class="flex flex-row">
											<div class="headline w-[40%] flex flex-row" style="align-items: center">
												<mat-icon [svgIcon]="icons.get('warmwater')" class="title-icon" id="icWarmwater"></mat-icon>
												<h2 class="margin-left-20">{{ t('uvi.warmwater') }}</h2>
												<mat-icon
													[siTooltip]="t('uvi.toolTipWarmwater')"
													[svgIcon]="icons.get('infoOutline')"
													class="align-bottom ml-1"
													color="primary"></mat-icon>
											</div>
										</div>
										<div>
											<div class="flex flex-row flex-wrap">
												<div [ngClass]="{ 'w-[100%]': isMobile, 'w-[50%]': !isMobile }" class="flex flex-row">
													<p [ngClass]="setBarStyleByDevice('left')">
														{{ formatDataLabel(consumption.lastYearConsumption.value) }}
													</p>
													<p [ngClass]="setBarStyleByDevice('mid')">
														{{ formatDataLabel(consumption.lastMonthConsumption.value) }}
													</p>
													<p [ngClass]="setBarStyleByDevice('right')">
														{{ formatDataLabel(consumption.currentConsumption.value) }}
													</p>
													<ngx-charts-bar-vertical
														[barPadding]="3"
														[customColors]="customColors"
														[gradient]="false"
														[legendTitle]="t('uvi.legend')"
														[legend]="false"
														[ngClass]="!isMobile ? 'margin-left-40' : ''"
														[results]="chartDataWarmwater"
														[roundDomains]="true"
														[showYAxisLabel]="showYAxisLabel"
														[view]="diagramSize"
														[xAxisTickFormatting]="xAxisTickFormattingFn"
														[xAxis]="showXAxis"
														[yAxisLabel]="t('uvi.diagramConsumption')"
														[yAxisTickFormatting]="yAxisTickFormattingFn"
														[yAxis]="showYAxis"
														id="chart_warmwater">
														<ng-template #tooltipTemplate let-model="model">
															<span class="tooltip-label">{{ model.name }}</span>
															<span class="tooltip-value">{{ scaleBy0(model.value) }}</span>
														</ng-template>
													</ngx-charts-bar-vertical>
												</div>

												<ng-template *ngTemplateOutlet="consumptionContent; context: { $implicit: consumption }"></ng-template>
												<div class="flex flex-col justify-start items-stretch" style="width: 100%; margin-top: 20px"></div>
											</div>
										</div>
									</div>
								}
								@if (consumption.costType === costTypeEnum.COLDWATER) {
									<div class="card p-6" style="margin-bottom: 10px">
										<div class="flex flex-row">
											<div class="headline flex flex-row w-[40%]" style="align-items: center">
												<mat-icon [svgIcon]="icons.get('coldwater')" class="title-icon" id="icColdwater"></mat-icon>
												<h2 class="margin-left-20">{{ t('uvi.coldwater') }}</h2>
												<mat-icon
													[siTooltip]="t('uvi.toolTipColdwater')"
													[svgIcon]="icons.get('infoOutline')"
													class="align-bottom ml-1"
													color="primary"></mat-icon>
											</div>
										</div>
										<div>
											<div class="flex flex-row flex-wrap">
												<div [ngClass]="{ 'w-[100%]': isMobile, 'w-[50%]': !isMobile }" class="flex flex-row">
													<p [ngClass]="setBarStyleByDevice('left')">
														{{ formatDataLabelWater(consumption.lastYearConsumption.value) }}
													</p>
													<p [ngClass]="setBarStyleByDevice('mid')">
														{{ formatDataLabelWater(consumption.lastMonthConsumption.value) }}
													</p>
													<p [ngClass]="setBarStyleByDevice('right')">
														{{ formatDataLabelWater(consumption.currentConsumption.value) }}
													</p>
													<ngx-charts-bar-vertical
														[barPadding]="3"
														[customColors]="customColors"
														[gradient]="false"
														[legendTitle]="t('uvi.legend')"
														[legend]="false"
														[ngClass]="!isMobile ? 'margin-left-40' : ''"
														[results]="chartDataColdwater"
														[roundDomains]="true"
														[showYAxisLabel]="showYAxisLabel"
														[view]="diagramSize"
														[xAxisTickFormatting]="xAxisTickFormattingFn"
														[xAxis]="showXAxis"
														[yAxisLabel]="t('uvi.diagramConsumptionQubic')"
														[yAxisTickFormatting]="yAxisTickFormattingFn"
														[yAxis]="showYAxis"
														id="chart_coldwater">
														<ng-template #tooltipTemplate let-model="model">
															<span class="tooltip-label">{{ model.name }}</span>
															<span class="tooltip-value">{{ scaleBy0(model.value) }}</span>
														</ng-template>
													</ngx-charts-bar-vertical>
												</div>
												<ng-template *ngTemplateOutlet="consumptionContent; context: { $implicit: consumption }"></ng-template>
												<div class="flex flex-col justify-start items-stretch" style="width: 100%; margin-top: 20px"></div>
											</div>
										</div>
									</div>
								}
								@if (consumption.costType === costTypeEnum.COOLING) {
									<div class="card p-6" style="margin-bottom: 10px">
										<div class="flex flex-row">
											<div class="headline flex flex-row w-[40%]" style="align-items: center">
												<mat-icon [svgIcon]="icons.get('cooling')" class="title-icon" id="icCooling"></mat-icon>
												<h2 class="margin-left-20">{{ t('uvi.cooling') }}</h2>
												<mat-icon
													[siTooltip]="t('uvi.toolTipCooling')"
													[svgIcon]="icons.get('infoOutline')"
													class="align-bottom ml-1"
													color="primary"></mat-icon>
											</div>
										</div>
										<div>
											<div class="flex flex-row flex-wrap">
												<div [ngClass]="{ 'w-[100%]': isMobile, 'w-[50%]': !isMobile }" class="flex flex-row">
													<p [ngClass]="setBarStyleByDevice('left')">
														{{ formatDataLabel(consumption.lastYearConsumption.value) }}
													</p>
													<p [ngClass]="setBarStyleByDevice('mid')">
														{{ formatDataLabel(consumption.lastMonthConsumption.value) }}
													</p>
													<p [ngClass]="setBarStyleByDevice('right')">
														{{ formatDataLabel(consumption.currentConsumption.value) }}
													</p>
													<ngx-charts-bar-vertical
														[barPadding]="3"
														[customColors]="customColors"
														[gradient]="false"
														[legendTitle]="t('uvi.legend')"
														[legend]="false"
														[ngClass]="!isMobile ? 'margin-left-40' : ''"
														[results]="chartDataCooling"
														[roundDomains]="true"
														[showYAxisLabel]="showYAxisLabel"
														[view]="diagramSize"
														[xAxisTickFormatting]="xAxisTickFormattingFn"
														[xAxis]="showXAxis"
														[yAxisLabel]="t('uvi.diagramConsumption')"
														[yAxisTickFormatting]="yAxisTickFormattingFn"
														[yAxis]="showYAxis"
														id="chart_cooling">
														<ng-template #tooltipTemplate let-model="model">
															<span class="tooltip-label">{{ model.name }}</span>
															<span class="tooltip-value">{{ scaleBy0(model.value) }}</span>
														</ng-template>
													</ngx-charts-bar-vertical>
												</div>
												<ng-template *ngTemplateOutlet="consumptionContent; context: { $implicit: consumption }"></ng-template>
												<div class="flex flex-col justify-start items-stretch" style="width: 100%; margin-top: 20px"></div>
											</div>
										</div>
									</div>
								}
								@if (consumption.costType === costTypeEnum.HEATING_WARMWATER) {
									<div class="card p-6" style="margin-bottom: 10px">
										<div class="flex flex-row">
											<div class="headline flex flex-row w-[40%]" style="align-items: center">
												<mat-icon [svgIcon]="icons.get('heatingWarmwater')" class="title-icon" id="icHeatingWarmwater"></mat-icon>
												<h2 class="margin-left-20">{{ t('uvi.heatingWarmwater') }}</h2>
												<mat-icon
													[siTooltip]="t('uvi.toolTipHeatingWarmwater')"
													[svgIcon]="icons.get('infoOutline')"
													class="align-bottom ml-1"
													color="primary"
													color="primary"></mat-icon>
											</div>
										</div>
										<div>
											<div class="flex flex-row flex-wrap">
												<div [ngClass]="{ 'w-[100%]': isMobile, 'w-[50%]': !isMobile }" class="flex flex-row">
													<p [ngClass]="setBarStyleByDevice('left')">
														{{ formatDataLabel(consumption.lastYearConsumption.value) }}
													</p>
													<p [ngClass]="setBarStyleByDevice('mid')">
														{{ formatDataLabel(consumption.lastMonthConsumption.value) }}
													</p>
													<p [ngClass]="setBarStyleByDevice('right')">
														{{ formatDataLabel(consumption.currentConsumption.value) }}
													</p>
													<ngx-charts-bar-vertical
														[barPadding]="3"
														[customColors]="customColors"
														[gradient]="false"
														[legendTitle]="t('uvi.legend')"
														[legend]="false"
														[ngClass]="!isMobile ? 'margin-left-40' : ''"
														[results]="chartDataHeatingWarmwater"
														[roundDomains]="true"
														[showYAxisLabel]="showYAxisLabel"
														[view]="diagramSize"
														[xAxisTickFormatting]="xAxisTickFormattingFn"
														[xAxis]="showXAxis"
														[yAxisLabel]="t('uvi.diagramConsumption')"
														[yAxisTickFormatting]="yAxisTickFormattingFn"
														[yAxis]="showYAxis"
														id="chart_heatingWarmwater">
														<ng-template #tooltipTemplate let-model="model">
															<span class="tooltip-label">{{ model.name }}</span>
															<span class="tooltip-value">{{ scaleBy0(model.value) }}</span>
														</ng-template>
													</ngx-charts-bar-vertical>
												</div>
												<ng-template *ngTemplateOutlet="consumptionContent; context: { $implicit: consumption }"></ng-template>
											</div>
										</div>
									</div>
								}
							</ng-container>
						}
					</ng-container>
				} @else {
					<div>
						<p>{{ t('uvi.selectDate') }}</p>
					</div>
				}
			</ng-container>
		}
	</vex-page-layout>
	@if (!selectedDate) {
		<div @fadeInUp class="flex flex-row justify-center">
			<span>{{ t('uvi.noUviExists') }}</span>
		</div>
	}
	@if (dateMismatch) {
		<div @fadeInUp class="flex flex-col items-center justify-center py-10 text-center">
			<mat-icon class="text-gray-400 text-4xl w-9 h-9 mb-2.5" fontSet="material-symbols-outlined">info</mat-icon>
			<span>{{ t('errors.dateMismatch') }}</span>
		</div>
	}
</div>
